
import React from "react";





const CoversCard = ({
  data,
  handleClick,
  isPodcastImage = false,
  isPreview = false,
}) => {
  return (
    <>
      <div
        onClick={() => {
          if (isPreview) return;
          handleClick();
        }}
        className="podcast-image-resource-container"
      >
        <img
          className={`clip-path-group2 image-select-none ${
            isPodcastImage ? "allApImgResource" : "podcast-image-resource"
          }`}
          src={data.src}
        />
      </div>
    </>
  );
};

export default CoversCard;
